import { css } from '@emotion/css';

export const certificateStyles = (imageUrl: string) => {
  return css`
    background-image: url(${imageUrl});
    width: 6.8rem;
  `;
};
